<template>
    <div>


    <form id="search">
        <a href="#bottom"> | Bottom | </a>
        <a name="top"></a>
        Search <input name="query" v-model="filterKey">
    </form>
    <table class="sortableGrid">
    <thead>
      <tr>
        <th>Order</th>
        <th v-for="(key, index) in columns"
            :key="index"
            @click="sortBy(key)"
            :class="[{ active: sortKey == key }, key]">
          {{ key | capitalize }}
          <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, index) in filteredHeroes" :key="index">
        <td>{{entry.index}}</td>
        <td v-for="key in columns" :key="key" :class="key">
          {{entry[key]}}
        </td>
      </tr>
    </tbody>
    <a name="bottom"></a>
    <a href="#top">| Top |</a>

  </table>
  </div>
</template>

<script>

export default {
  name: 'SortableGrid',
  props: {
    heroes: Array,
    columns: Array,
    filterKey: String
  },
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders,
    }
  },
  computed: {
    filteredHeroes: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var heroes = this.heroes
      if (filterKey) {
        heroes = heroes.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        heroes = heroes.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
        
      }

      var index = 1;
      heroes.forEach(function (hero) {
        hero.index = index++;
      })

      return heroes
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

table {
  border: 2px solid #42b983;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #42b983;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

th, td {
  min-width: 90px;
  padding: 1px 1px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}


td.target, td.hr, td.points, td.numberSelected, td.percentOfTarget, td.projectedPoints, td.plateAppearances, td.games {
  text-align: right;
}

th.target, th.hr, th.points, th.numberSelected, th.percentOfTarget, th.projectedPoints, th.plateAppearances, th.games {
  text-align: right;
}
div {
  text-align: left;
}
</style>
